<template>
  <div class="about">
    <h1 class="about-title">
      gifteeとは
    </h1>
    <AboutCoverSection />
    <CreateGiftButton
      class="about-create-gift-button"
      @click-button="onClickCreateGiftButton"
    />
    <AboutBrandsSection />
    <AboutScenesSection />
    <AboutHowToUsesSection />
    <AboutWishListSection />
    <AboutReceivingKindsSection />
    <AboutCardDesignsSection />
    <AboutAppStoreSection />
  </div>
</template>

<script setup>
import AboutCoverSection from '../../organism/statics/abouts/AboutCoverSection.vue'
import AboutBrandsSection from '../../organism/statics/abouts/AboutBrandsSection.vue'
import AboutScenesSection from '../../organism/statics/abouts/AboutScenesSection.vue'
import AboutHowToUsesSection from '../../organism/statics/abouts/AboutHowToUsesSection.vue'
import AboutWishListSection from '../../organism/statics/abouts/AboutWishListSection.vue'
import AboutReceivingKindsSection from '../../organism/statics/abouts/AboutReceivingKindsSection.vue'
import AboutCardDesignsSection from '../../organism/statics/abouts/AboutCardDesignsSection.vue'
import AboutAppStoreSection from '../../organism/statics/abouts/AboutAppStoreSection.vue'
import CreateGiftButton from '../../molecules/buttons/CreateGiftButton.vue'

function onClickCreateGiftButton() {
  location.href = '/gift_card/new'
}
</script>

<style lang="scss" scoped>
.about {
  width: 100%;
  letter-spacing: 0.06em;

  &-title {
    display: none;
  }

  &-create-gift-button {
    position: fixed;
    right: 3%;
    bottom: 3%;
    z-index: 2; // AboutWishListSectionで使用しているSwiperがz-index:1を使用しており、それより上に表示するため2を指定。
  }
}
</style>
